// =============================
// Email: info@xx.com
// www.xx.com/templates
// =============================

import { Directive, ElementRef, OnInit } from '@angular/core';


@Directive({
    selector: '[appAutofocus]',
    standalone: false
})
export class AutofocusDirective implements OnInit {
  constructor(public elementRef: ElementRef) { }

  ngOnInit() {
    setTimeout(() => this.elementRef.nativeElement.focus(), 500);
  }
}
